import { connect } from 'react-redux';
import {
  fetchOtherVendorsList,
  fetchOtherVendor,
  createOtherVendorAction,
  updateOtherVendorAction,
  clearOtherVendorsError,
} from '../../../actions/vendors/otherVendors';

import { AddVendorContent } from './AddVendorContent';

const mapStateToProps = (state: {
  otherVendors: any;
  vendor: any;
  common: any;
}) => {
  const { otherVendors, vendor, common } = state;
  return {
    vendors: otherVendors,
    vendorForm: otherVendors.vendorForm || {
      id: null,
      name: '',
      description: '',
      vendor_url: '',
      errorName: false,
      errorDescription: false,
      avatarPath: '',
      spinner: false,
      redirectTo: '',
      isFormUpdated: false,
    },
    common,
  };
};

// Actions to dispatch form updates
const mapDispatchToProps = (dispatch: any) => ({
  getOtherVendorsList: () => dispatch(fetchOtherVendorsList()),
  clearAddVendor: () => dispatch({ type: 'CLEAR_VENDOR_FORM' }),
  onChangeVendorName: (value: string) => dispatch({ type: 'UPDATE_VENDOR_NAME', payload: value }),
  onChangeVendorDescription: (value: string) => dispatch({ type: 'UPDATE_VENDOR_DESCRIPTION', payload: value }),
  onChangeVendorUrl: (value: string) => dispatch({ type: 'UPDATE_VENDOR_URL', payload: value }),
  onChangeVendorAvatarImage: (file: File) => dispatch({ type: 'UPDATE_VENDOR_IMAGE', payload: file }),
  onAddVendor: (vendorData: any) => dispatch(createOtherVendorAction(vendorData)),
  getOtherVendor: (id: number) => dispatch(fetchOtherVendor(id)),
  onEditVendor: (id: number, vendorData: any) => dispatch(updateOtherVendorAction(id, vendorData)),
});

export const AddVendor = connect(mapStateToProps, mapDispatchToProps)(AddVendorContent);
